// Defines default feature flags
export const DEFAULT_FEATURES = {
  b2c: true,
  b2b: true,
  sailabCode: false,
  organisation: false,
}
